import WMICPolicyChange from './WMICPolicyChange/WMICPolicyChange';
import WMICPolicyDetails from './WMICPolicyDetails/WMICPolicyDetails';

const policyComponentMap = {
    WMICPolicyDetails: { component: 'WMICPolicyDetails' },
    WMICPolicyChange: { component: 'WMICPolicyChange' }
};

const policyComponents = {
    WMICPolicyDetails,
    WMICPolicyChange
};

export {
    WMICPolicyDetails,
    WMICPolicyChange,
    policyComponentMap,
    policyComponents
};

export { default as WMICPolicyInfoBox } from './WMICPolicyInfoBox/WMICPolicyInfoBox';
export { default as WMICBillingInfoBox } from './WMICBillingInfoBox/WMICBillingInfoBox';
export { default as WMICManageBankingInformation } from './WMICManageBankingInformation/WMICManageBankingInformation';
export { default as WMICBankAccount } from './WMICManageBankingInformation/WMICBankAccount';
export { default as WMICPolicyChangePaymentPlanBox } from './WMICPolicyChangePaymentPlanBox/WMICPolicyChangePaymentPlanBox';
export { default as WMICPolicyDetailsUtil } from './WMICPolicyDetailsUtil';
export { default as WMICVehiclesInfoBox } from './WMICVehiclesInfoBox/WMICVehiclesInfoBox';
export { default as WMICVehicleInfoBox } from './WMICVehicleInfoBox/WMICVehicleInfoBox';
export { default as WMICDriversInfoBox } from './WMICDriversInfoBox/WMICDriversInfoBox';
export { default as WMICPolicyCoverageInfoBox } from './WMICPolicyCoverageInfoBox/WMICPolicyCoverageInfoBox';
export { default as WMICLocationInfoBox } from './WMICLocationInfoBox/WMICLocationInfoBox';
export { default as WMICInsuranceCardModal } from './WMICInsuranceCardModal/WMICInsuranceCardModal';
export { default as WMICChangePaymentPlanErrorModal } from './WMICChangePaymentPlanErrorModal/WMICChangePaymentPlanErrorModal';
export { default as WMICModal } from './WMICModal/WMICModal';
export { default as WMICTriggerInsuranceCardModal } from './WMICInsuranceCardModal/WMICTriggerInsuranceCardModal';
export { default as WMICPolicyDocuments } from './WMICPolicyDocuments/WMICPolicyDocuments';
export { default as WMICManagePaymentPlan } from './WMICBillingInfoBox/WMICManagePaymentPlan/WMICManagePaymentPlan';